module.exports = __webpack_public_path__ + "static/media/ship.c6460c08.svg";